import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import { CustomDialog } from './customDialog/CustomDialog';

export default function ErrorDialog(props) {
    const { onClose, open, mensaje } = props;

    const handleAceptar = () => {
        onClose();
    };

    const textoMensaje = () => {
        // si mensaje es un número el mismo corresponde al código de error. En caso contrario
        // se muestra un texto genérico de error de conexión o de base de datos
        let texto = mensaje;

        if (parseInt(texto, 10) > 0) {
            return (
                <div style={{ fontSize: '10pt' }}>
                    Se produjo un error en el sistema y se ha generado el <strong>código <span style={{ fontSize: '13pt' }}>{mensaje}</span></strong> como referencia asociada.
                    <br /><br />
                    Por favor <strong>cargar un ticket mencionando dicho número</strong> para proceder al tratamiento de su resolución.
                </div>
            )
        } else {
            return (
                <div style={{ fontSize: '10pt' }}>
                    Se produjo un error en el sistema debido a un <strong>problema de conexión con el servidor y/o la base de datos.</strong>
                    <br /><br />
                    Por favor comunicarse con la Gerencia de Sistemas.
                </div>
            )
        }
    };

    return (
        <CustomDialog
            maxWidth="md"
            open={open}
            onAccept={handleAceptar}
        >
            <div style={{ color: '#C70039', display: 'flex', width: '100%', marginBottom: 20 }}>
                <div style={{ width: '30px' }}><ErrorIcon /></div>
                <div style={{ fontSize: '13pt', fontWeight: 'bold' }}>Error</div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ fontSize: '13pt' }}>
                    {textoMensaje()}
                </div>
            </div>
        </CustomDialog>
    )
}